export const ContentMinHeight = "calc(100vh - 131px)";

export const ContentBackgroundColor = "#f5f5f5";
// export const MainColor = "#245496";
export const MainColor = "#17375f";
export const SubColor = "#3068a4";

export const BoxStyle: React.CSSProperties = {
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  padding: "1rem",
};
